import React, { useEffect, useState } from 'react'
import { useAuth } from "../context/AuthContext";

const GoogleSignIn = (props) => {
    const { currentUser, authSignIn } = useAuth();

    useEffect(() => {
        /* global google */
        const handleCredentialResponse = (response) => {
            console.log('Encoded JWT ID token: ' + response.credential);
            // You can send the token to your server for verification and user session management
            const formData = new FormData();
            formData.append('id_token', response.credential);
            formData.append('request_from', 'webapp');

            fetch('https://www.dcfever.com/users/google/googlecallback.php', {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    console.log(data);
                    if (data.status === true) {
                        if (data.access_token) {
                            authSignIn(data.access_token);
                        } else if (data.next_action === 'redirect') {
                            if (data.redirect_url) {
                                window.location.href = data.redirect_url;
                            } else {
                                window.location.href = "https://www.dcfever.com/users/index.php";
                            }
                        } else {
                            window.location.href = "https://www.dcfever.com/users/googlenext.php";
                        }
                    } else {
                        if (data.error_message) {
                            alert(data.error_message);
                        }
                        console.error("Login failed:", data);
                    }
                })
                .catch(error => {
                    console.error("Fetch error:", error);
                });
        };

        /* Initialize the Google Sign-In client */
        google.accounts.id.initialize({
            client_id: '293799188096-pav0eedm7mkurv7hcut64ftthvpteic2.apps.googleusercontent.com',
            callback: handleCredentialResponse
        });

        google.accounts.id.renderButton(
            document.getElementById('buttonDiv'),
            { theme: 'outline', size: 'large', shape: 'pill', width: 320 }  // customization attributes
        );

        //google.accounts.id.prompt(); // Display the One Tap prompt
    }, []);

    return (
        <div>
            <div id="buttonDiv"></div>
        </div>
    )
}

export default GoogleSignIn;